var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"text-white text-md px-4 py-2 bg-green-500 border border-transparent rounded-md shadow-sm hover:bg-green-600 focus:border-green-500 focus:ring-green-500",attrs:{"type":_vm.type}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }